import axios from "../axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import "../styles/Row.css";
import { motion } from "framer-motion";
import Nav from "./Nav";

const Row = ({ title, fetchURL, isLargeRow = false }) => {
  const [movies, setMovies] = useState([]);
  const [modal, setModal] = useState(false);
  const [singleItem, setSingleItem] = useState({});

  const openModal = (
    movieId,
    backdropPath,
    posterPath,
    overview,
    title,
    movieName
  ) => {
    setSingleItem({
      id: movieId,
      backdropPath,
      posterPath,
      overview: overview,
      title,
      name: movieName,
    });
    setModal(true);
    console.log(modal);
  };

  const base_url = "https://image.tmdb.org/t/p/original/";

  useEffect(() => {
    const fetchData = async () => {
      const request = await axios(fetchURL);
      setMovies(request?.data.results);
      return request;
    };

    fetchData();
  }, [fetchURL]);

  console.log(movies);
  return (
    <>
      <div className="row">
        <h2>{title}</h2>

        <div className="row__posters">
          {movies.map(
            (movie) =>
              ((isLargeRow && movie.poster_path) ||
                (!isLargeRow && movie.backdrop_path)) && (
                <img
                  className={`row__poster ${isLargeRow && "row__posterLarge"}`}
                  key={movies?.id}
                  src={`${base_url}${
                    isLargeRow ? movie.poster_path : movie.backdrop_path
                  }`}
                  alt={movie.name}
                  srcSet=""
                  onClick={() =>
                    openModal(
                      movie.id,
                      movie.backdrop_path,
                      movie.poster_path,
                      movie.overview,
                      movie.title,
                      movie.name
                    )
                  }
                />
              )
          )}
        </div>
        {modal ? (
          <>
            <Nav />
            <motion.div
              className="modal"
              cx={500}
              animate={{ cx: [null, 100, 200] }}
              transition={{ duration: 3, times: [0, 0.2, 1] }}
            >
              <div className="modal-content">
                {/* <div>
                  <img
                    src={`${base_url}/${singleItem.backdropPath}`}
                    alt=""
                    srcSet=""
                  />
                </div> */}
                <div className="modal-content-text">
                  <span onClick={() => setModal(false)}>
                    {" "}
                    <h6 className="x">X</h6>
                  </span>
                  <h1>{singleItem.title || singleItem.name}</h1>
                  <h3>{singleItem.overview}</h3>
                </div>
              </div>
            </motion.div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default Row;
